import { Calendar } from "lucide-react";
import {
  Create,
  Datagrid,
  DateField,
  DateTimeInput,
  Edit,
  List,
  TabbedForm,
  FormTab,
  TextField,
  TextInput,
  TopToolbar,
  FilterButton,
  CreateButton,
  useNotify,
  useRedirect,
  useRefresh,
} from "react-admin";
import { EditorToolbar } from "../../components";
import { DownloadExportButton2 } from "../../components/list/DownloadExportButton";

function renderEditForm() {
  return (
    <TabbedForm toolbar={<EditorToolbar />}>
      <FormTab label="Details" replace>
        <TextInput
          source="name"
          label="Period Name"
          helperText="e.g., '2025 Campaign'"
          required
        />
        <DateTimeInput
          source="start_date"
          label="Start Date"
          required
        />
        <DateTimeInput
          source="end_date"
          label="End Date"
          required
        />
      </FormTab>
    </TabbedForm>
  );
}

function CreateView(props) {
  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();
  return (
    <Create
      {...props}
      mutationMode="pessimistic"
      mutationOptions={{
        onSuccess: () => {
          notify("Credit period created successfully!", {
            type: "success",
          });
          refresh();
          redirect("list", "ta-credit-periods");
        },
        onError: (error) => {
          notify(`Error: ${error.message}`, { type: "error" });
        },
      }}
    >
      {renderEditForm()}
    </Create>
  );
}

function EditView(props) {
  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();
  return (
    <Edit
      {...props}
      mutationMode="pessimistic"
      mutationOptions={{
        onSuccess: () => {
          notify("Credit period updated successfully!", {
            type: "success",
          });
          refresh();
          redirect(false);
        },
        onError: (error) => {
          notify(`Error: ${error.message}`, { type: "error" });
        },
      }}
    >
      {renderEditForm()}
    </Edit>
  );
}

const ListActions = () => {
  return (
    <TopToolbar>
      <FilterButton />
      <CreateButton />
      <DownloadExportButton2 />
    </TopToolbar>
  );
};

function ListView(props) {
  return (
    <List
      {...props}
      actions={<ListActions />}
      exporter={true}
      filters={[
        <TextInput
          source="name"
          label="Period Name"
          key="name"
          alwaysOn
        />,
      ]}
      sort={{ field: "start_date", order: "DESC" }}
      title="TA Credit Periods"
    >
      <Datagrid rowClick="edit" bulkActionButtons={false}>
        <TextField source="id" label="ID" />
        <TextField source="name" label="Period Name" />
        <DateField source="start_date" label="Start Date" showTime />
        <DateField source="end_date" label="End Date" showTime />
        <DateField source="created_at" label="Created" showTime />
      </Datagrid>
    </List>
  );
}

export const TaCreditPeriods = {
  category: "database",
  name: "ta-credit-periods",
  options: { label: "TA Credit Periods" },
  create: CreateView,
  edit: EditView,
  icon: Calendar,
  list: ListView,
  recordRepresentation: (record) => record.name,
};
